/**
 * Is a WiFi rename to `nextName` currently HELD by this vendo's NodeMCU
 * being offline?
 *
 * The router refuses to rename its radio until the NodeMCU has been handed
 * the new name (the box can only rejoin a name it already holds), so a rename
 * saved while the box is silent parks in an invisible forever-wait: dashboard
 * says renamed, radio never changes (JOANS WIFI VENDO, 2026-09-10). Both
 * rename screens disable Save on this rule, and the server refuses the write
 * too (409 coinbox-offline).
 *
 * ONE exception, the rescue direction: renaming TO the name the NodeMCU was
 * flashed for (nodeMcu.wifiSsid). A box flashed for X while the router
 * broadcasts Y is offline BECAUSE of the gap, and aligning the router to X is
 * the only remote fix — it cannot strand a box that is not connected anyway.
 *
 * `status` is the COIN BOX's liveness on Lite devices (the router's own is
 * `router.lastSeenAt`). A vendo with no NodeMCU at all (no nodeMcu.mac) has
 * nothing to hand over and renames freely.
 */
export function coinBoxHoldsRename(
   device: {
      status?: string;
      nodeMcu?: { mac?: string; wifiSsid?: string };
   },
   nextName?: string
): boolean {
   if (!device.nodeMcu?.mac) return false;
   if (device.status === 'online') return false;
   const boxName = (device.nodeMcu.wifiSsid || '').trim();
   if (boxName && (nextName || '').trim() === boxName) return false; // rescue
   return true;
}

/** The one name still savable while the NodeMCU is offline, if any. */
export function coinBoxRescueName(device: {
   nodeMcu?: { mac?: string; wifiSsid?: string };
}): string {
   return (device.nodeMcu?.wifiSsid || '').trim();
}
